import AuthOffcanvas from "@components/core/AuthOffcanvas";
import {
  useUserListsManager,
  useCloseAuthOffcanvasPriorToLikeProduct,
  useIsAuthOffcanvasPriorToLikeProductOpen,
} from "@hooks/use-userlists";
import { useLikeProduct } from "@hooks/use-current-user";

function AuthOffcanvasPriorToLikeProduct() {
  const { product } = useUserListsManager();
  const closeAuthOffcanvasPriorToLikeProduct = useCloseAuthOffcanvasPriorToLikeProduct();
  const isAuthOffcanvasPriorToLikeProductOpen = useIsAuthOffcanvasPriorToLikeProductOpen();
  const likeProduct = useLikeProduct();

  function likeProductAfterAuthAction() {
    likeProduct(product);
    closeAuthOffcanvasPriorToLikeProduct();
  }

  return (
    <AuthOffcanvas
      open={isAuthOffcanvasPriorToLikeProductOpen}
      initType="signin"
      userAction="likeProduct"
      onHide={closeAuthOffcanvasPriorToLikeProduct}
      onAfterAuth={likeProductAfterAuthAction}
    />
  );
}

export default AuthOffcanvasPriorToLikeProduct;
